module.exports = __webpack_public_path__ + "img/pants.be5030ca.webp";